import { createApp, onMounted, ref } from "vue";
export default class MobileMenu {
    constructor(el, lazyLoader) {
        const app = createApp({
            setup() {
                const isOpened = ref(false);
                const activeMenu = ref(null);
                const mobileMenuTrigger = document.querySelectorAll('.js-open-mobile-menu');
                mobileMenuTrigger.forEach(trigger => {
                    trigger.addEventListener('click', () => {
                        toggleMenu();
                    });
                });
                const toggleMenu = () => {
                    isOpened.value = !isOpened.value;
                    if (isOpened.value)
                        document.body.classList.add('show-shader');
                    else
                        document.body.classList.remove('show-shader');
                };
                const toggleDropdown = (event) => {
                    if (!event.currentTarget)
                        return;
                    const parent = event.currentTarget.parentNode;
                    if (!parent)
                        return;
                    parent.classList.toggle('nested-open');
                };
                onMounted(() => {
                    lazyLoader.update();
                });
                return {
                    isOpened,
                    activeMenu,
                    toggleMenu,
                    toggleDropdown,
                };
            }
        });
        app.mount(el);
    }
}
